export const WORKER_DUPLICATE_ACCOUNTS_COUNT_FETCH_BEGIN =
  'syftacp/WORKER_DUPLICATE_ACCOUNTS_COUNT_FETCH_BEGIN' as const
export const WORKER_DUPLICATE_ACCOUNTS_COUNT_FETCH_FAILED =
  'syftacp/WORKER_DUPLICATE_ACCOUNTS_COUNT_FETCH_FAILED' as const
export const WORKER_DUPLICATE_ACCOUNTS_COUNT_FETCH_SUCCEEDED =
  'syftacp/WORKER_DUPLICATE_ACCOUNTS_COUNT_FETCH_SUCCEEDED' as const
